import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from "@mui/material";
import { GiNightSleep, GiNotebook } from "react-icons/gi";
import { useDispatch } from "react-redux";
import { dialogSlice } from "../../data/dialogSlice";
import { useSnackbar } from "notistack";
import { babyTrackerApi } from "../../data/babyTrackerApi";
import { useOnErrorNotification } from "../../hooks/notifications";

export default function LogActionList() {
  const dispatch = useDispatch();
  const [createSleep] = babyTrackerApi.useCreateSleepMutation();
  const { enqueueSnackbar } = useSnackbar();
  const onError = useOnErrorNotification();

  const logItems = [
    {
      icon: <GiNotebook />,
      text: "Note",
      action: () => dispatch(dialogSlice.actions.openNoteDialog()),
    },
    {
      icon: <GiNightSleep />,
      text: "Sweepy",
      action: () =>
        dispatch(
          dialogSlice.actions.openSleepDialog({
            title: "How long did Ada sweepy?",
            inputTitle: "Hours sweepied",
            valueKey: "durationMinutes",
            onSave: ({ value, notes, date }) =>
              createSleep({
                durationMinutes: value * 60,
                notes,
                date: date.toISOString(),
              }).then(() => {
                enqueueSnackbar("Sweepy recorded", {
                  variant: "success",
                });
              }, onError),
          })
        ),
    },
  ];

  return (
    <>
      <ListSubheader>Logging</ListSubheader>
      {logItems.map((item) => (
        <ListItem disablePadding key={item.text}>
          <ListItemButton onClick={item.action}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
        </ListItem>
      ))}
    </>
  );
}
